import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

const Sidebar = ({ setOpen}) => {
  const navigate = useNavigate();
  const menuItems = [
    // {
    //   title: 'Dashboard',
    //   link: '/'
    // },
    {
      title: 'Registered Vehicles',
      link: '/tickets'
    },
    {
      title: 'Profile',
      link: '/profile'
    }
  ]

  const logout = () => {
    localStorage.clear();
    setOpen(false);
    toast.success('Logged out successfully.');
    window.location.reload();
    navigate('/member-login');

  }
  return (
    <aside className="w-64 bg-[#212121] text-white border-r min-h-screen ">
      <div className="mb-12 flex justify-center w-full p-4">
        <img src="./logo-transparent-png.png" alt="Logo" width='70%'/>
      </div>
      <nav className="flex flex-col gap-2 text-white justify-between h-2/3">
        <div className='flex flex-col gap-2 '>
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              // activeClassName="bg-gray-600"
              onClick={() => {window.innerWidth < 768 && setOpen(false)}}
              className={
                `py-2 px-4 rounded-lg transition duration-300 ease-in-out ${window.location.pathname === item.link
                  ? 'bg-black'
                  : 'hover:bg-gray-600 '
                }`
              }
            >
              {item.title}
            </Link>
          ))}
        </div>
        <button
          type="button"
          className="w-2/3 bg-teal-500 hover:bg-teal-600 text-white py-2 rounded mt-4 mx-auto"
          onClick={logout}
        >
          Logout
        </button>
      </nav>
      <ToastContainer
        position="top-right"
        autoClose={5000}
      />
    </aside>
  );
};

export default Sidebar;
